import React from 'react';
import { withRouter, Link } from 'react-router-dom';

//HELPERS
import $ from 'jquery';
import * as c from '../helpers/constants'
import { callApi } from '../helpers/methods'
import { isBlank } from '../helpers/stringHelper'

//REDUX
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { listaAction } from '../store/lista';

//LAYOUT
import PrivateLayout from '../layouts/private'

//COMPONENTS
import {Row, Column, IBox, Title, Content, Button, Return, SelectCentroCusto, Select} from '../components/inspinia';
import CircularProgress from '@material-ui/core/CircularProgress';
import ModalSucesso from '../components/campanha/modalSucessoValidacao';
import { getToken, isAuthenticated, TOKEN_KEY, TOKEN_DATE } from '../store/auth';
import { EMAIL } from '../store/tipoListaEmail';

class ValidacaoEmail extends React.PureComponent
{
    constructor(props)
    {
        super(props); 
        
        this.state = 
        {
            loading: false,

            form: this.formInitialState(),

            file: null,

            modalSucessoIsOpen: false,

            comboEmpresa: {
                results: undefined
            },

            comboCentroCusto: {
                results: undefined
            },

            optionsGet: { method: 'GET', headers: { 'Content-Type': 'application/json' } },
        }

        this.handleChange = this.handleChange.bind(this);
        this.handleSave   = this.handleSave.bind(this);
        this.onChangeFile = this.onChangeFile.bind(this);
        this.handleSucessoToggle = this.handleSucessoToggle.bind(this);
        this.handleChangeEmpresaCentroCusto = this.handleChangeEmpresaCentroCusto.bind(this);
        this.resetForm = this.resetForm.bind(this);
        this.fileInputRef = React.createRef();
    }

    formInitialState () 
    {

        return {
            empresa: { },
            centroCusto: { },
            nomeListaContato: "",
            file: ""
        }

    }

    componentDidMount()
    {
        this.loadComboEmpresa();
    }

    resetForm() {
        this.setState({
            form: this.formInitialState(),
            file: null
        });
    
        if (this.fileInputRef.current) {
            this.fileInputRef.current.value = null;
        }
    
        const fileLabel = document.getElementsByClassName('custom-file-label').item(0);
        if (fileLabel) {
            fileLabel.textContent = "Selecione o arquivo";
        }
    }

    loadComboEmpresa() {
        let self = this
        const data = JSON.stringify({
            'id_produto': EMAIL
        });

        const url = `${c.API_BASE_URL}/company-user`;
        
        const options = {
            method: 'POST',
            body: data
        };

        self.setState({ ...self.state, loading: true })

        callApi(url, options, function (response) {
            self.setState({ ...self.state, loading: false, comboEmpresa: response });
        });
    }

    loadComboCentroCusto(idEmpresa) {
        let self = this;
        
        const url = `${c.API_BASE_URL}/centroCusto-empresa/${idEmpresa}`;
        const options = self.state.optionsGet;

        self.setState({ ...self.state, loading: true })

        if (!this.isIdEmpresaVazio(idEmpresa)) {
            callApi(url, options, function (response) {
                self.setState({ ...self.state, loading: false, comboCentroCusto: response });
            });
        } else {
            self.setState({ ...self.state, loading: false, comboCentroCusto: {results: undefined} })
        }
    }

    isIdEmpresaVazio(idEmpresa) {
        return (isNaN(idEmpresa) || idEmpresa === undefined || idEmpresa === '' || idEmpresa === "")
    }

    handleChangeEmpresaCentroCusto(e) {
        const valor = e.target.value;
        const index = e.target.selectedIndex;
        const texto = e.target[index].text;
        let nome = e.target.name;

        if (nome === "empresa") {
            this.setState(prevState => {
                const inputs = { ...prevState.form };
                
                inputs.empresa.id = parseInt(valor);
                inputs.empresa.nome = texto;
                this.loadComboCentroCusto(inputs.empresa.id);
                return { inputs }
            });
        } else if (nome === "centroCusto") {

            this.setState(prevState => {
                const inputs = { ...prevState.form };

                inputs.centroCusto.id = parseInt(valor);
                inputs.centroCusto.nome = texto;
                return { inputs }
            });
        }
    }

    handleChange(e)
    {
        const form = this.state.form;

        this.setState({ form: { ...form, [e.target.name]: e.target.value } });
    }

    handleSucessoToggle(e) {
        const newModalState = !this.state.modalSucessoIsOpen;
    
        this.setState({ modalSucessoIsOpen: newModalState }, () => {
            if (!newModalState) {
                this.resetForm();
            }
        });
    }

    onChangeFile(e) 
    {
        const form = this.state.form;
        
        form.file = e.target.files[0];        

        this.setState({file:e.target.files[0]});

        if(form.file != null){
            document.getElementsByClassName('custom-file-label').item(0).textContent = form.file.name
        }else{
            document.getElementsByClassName('custom-file-label').item(0).textContent = "Selecione o arquivo";
        }
    }

    handleSave(e)
    {
        e.preventDefault(); if (this.state.loading) return;
        if(this.state.form.file === '' || isBlank(this.state.form.nomeListaContato)){
            c.TOASTER_ERROR('Favor incluir nome do arquivo e o arquivo.');
            
        } else if (isBlank(this.state.form.centroCusto) || isNaN(this.state.form.centroCusto.id)) {
            c.TOASTER_ERROR('Favor selecionar empresa e centro de custo.');
        } else {
            let self = this;
            let auth = self.props.auth;
            let user = auth.user;
            this.state.form.email = user.email;
        
            this.props.actions.lista.uploadValidacao(this.state.form).then((response) => {
                this.setState({...this.state, loading: false });
                if (response.status == 200) {                    
                    this.handleSucessoToggle();
                } else {
                    let mensagemErro = response.userMessage != null ? response.userMessage : response.detail;
                    c.TOASTER_ERROR(mensagemErro);
                }
    
            }).catch((error) => 
            {
                this.setState({...this.state, loading: false });
                if (error.message) c.TOASTER(error.type, error.message); else c.TOASTER_ERROR(c.NETWORK_ERROR);
            });
        }
        
    }

    render()
    {
        const form = this.state.form;
        
        return (  

			<PrivateLayout navActiveItem={c.NAV_PANEL}>		
				<div>

                <ModalSucesso  isOpen={this.state.modalSucessoIsOpen}  toggle={this.handleSucessoToggle} />

					{/* MAIN CONTENT */}
					<Row className="mb-5">
						<Column>
							<IBox>
								<Title className="pt-5 text-center">
									<h2 className="fs-20 fw-600 text-body">Validação de E-mails</h2>

									<h5 className="fs-14 fw-400 text-body">Tipos de Arquivos Permitidos: Formato de arquivos separados por ponto e vírgula (*.csv; .txt).</h5>
									<p/>
									<h5 className="fs-14 fw-400 text-body">A primeira linha do arquivo deverá conter o nome dos campos. (nome; email...)</h5>
								</Title>

								<Content className="p-3 border-0">
									{/* FORMULÁRIO */}
									<Row className="m-0 mb-5">
                                        <Column size="9" className="container mx-auto p-0">
                                            
                                            <Row className="mt-4">
												<Column size="7" className="px-1">
                                                    <div className="form-group mb-0">
                                                        <Select name="empresa" selected={form.empresa.id} data={this.state.comboEmpresa} onChange={this.handleChangeEmpresaCentroCusto} placeholder="Empresa" />
                                                    </div> 
												</Column>

												<Column size="5" className="px-1">
                                                    <div className="form-group mb-0">
                                                        <SelectCentroCusto name="centroCusto" selected={form.centroCusto.id} data={this.state.comboCentroCusto} onChange={this.handleChangeEmpresaCentroCusto} placeholder="Centro de Custo" />                                            
                                                    </div>
												</Column>
											</Row>
											
											<Row className="mt-4">
												<Column size="7" className="px-1">                                                 
													
													<div className="input-group">
														<input type="text" name="nomeListaContato" value={form.nomeListaContato} onChange={this.handleChange} placeholder="Nome da nova Lista" className="form-control" /> 
													</div>

												</Column>

												<Column size="5" className="px-1">

													<div className="custom-file">
														<input type="file" name="file" className="custom-file-input" id="validatedCustomFile" required value={this.state.arquivo} ref={this.fileInputRef}  onChange={this.onChangeFile}/>
														<label className="custom-file-label" for="validatedCustomFile">Selecione o arquivo</label>
													</div>

												</Column>
											</Row>
									
										</Column>
									</Row>

									{/* NAVEGAÇÃO */}
									<Row className="m-0 mb-3">
										<Column size="auto" className="mx-auto">
											<div className="input-group">

												<Return to={c.PANEL_ROUTE} className="mx-1" width="130px" />     
												<Button onClick={this.handleSave} className="mx-1" width="130px">Enviar</Button>

												<div className="ml-4">
													{this.state.loading && (                    
														<CircularProgress 
															size={30} 
															thickness={4} 
															color='inherit'
															variant='indeterminate'/>                    
													)}
												</div>
											</div>
										</Column>
									</Row>
								</Content>
							</IBox>           
						</Column>
					</Row>             
				</div>
				
			</PrivateLayout>
        );
    }
}

function mapStateToProps(state)
{
    return { auth: state.auth, lista: state.lista };
}
function mapDispatchToProps(dispatch)
{
    return { actions: { lista: bindActionCreators(listaAction, dispatch) } };
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(ValidacaoEmail));
